<script setup lang="ts">
  import { computed, ref } from 'vue'

  const props = defineProps<{
    list: { name: string; label?: string }[]
    modelValue?: string
    full?: boolean
  }>()

  const index = ref<number>(0)
  const activeTab = computed(() =>
    props.modelValue ? props.list.findIndex((i) => i.name === props.modelValue) : index.value,
  )
</script>

<template>
  <div>
    <div class="flex max-md:overflow-x-scroll" role="tablist">
      <div
        class="h-9 px-4 xl:px-8 py-2 border-b-2 text-center text-sm font-medium cursor-pointer whitespace-nowrap transition-colors select-none"
        v-for="(item, i) in list"
        :key="i"
        role="tab"
        :aria-selected="activeTab === i"
        :class="{
          'border-blue-50 text-blue-10': activeTab === i,
          'border-transparent text-black-40 hover:border-black-90': activeTab !== i,
          'grow': full,
        }"
        @click="
          () => {
            index = i
            $emit('update:modelValue', item.name)
          }
        "
        v-show="item.label"
      >
        {{ item.label }}
      </div>
    </div>
    <div v-for="(item, i) in list" :key="i" :class="activeTab === i ? 'block' : 'hidden'">
      <slot :name="item.name"></slot>
    </div>
  </div>
</template>
